import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    clientSecret: String,
    returnUrl: String,
    publishableKey: String
  }

  static targets = ["paymentElement", "errorMessage", "submitButton"]

  connect() {
    this.stripe = Stripe(this.publishableKeyValue)
    var isMobile = window.matchMedia && window.matchMedia("(max-width: 640px)").matches
    var inputSize = isMobile ? "16px" : "14px"
    this.elements = this.stripe.elements({
      clientSecret: this.clientSecretValue,
      fonts: [{ cssSrc: "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500&display=swap" }],
      appearance: {
        theme: "flat",
        variables: {
          fontFamily: "'DM Sans', sans-serif",
          fontSizeBase: inputSize,
          fontSizeSm: "12px",
          colorPrimary: "#1A1410",
          colorText: "#1A1410",
          colorTextSecondary: "#6B5E52",
          colorTextPlaceholder: "#B8A99A",
          colorBackground: "#FFFFFF",
          borderRadius: "8px",
          spacingUnit: "4px",
          spacingGridRow: "14px",
          spacingGridColumn: "14px"
        },
        rules: {
          ".Input": {
            border: "1.5px solid #E0D5C8",
            padding: "10px 14px",
            fontSize: inputSize,
            transition: "border-color 0.2s"
          },
          ".Input:focus": {
            border: "1.5px solid #1A1410",
            boxShadow: "none"
          },
          ".Label": {
            fontSize: "12px",
            fontWeight: "500",
            color: "#6B5E52"
          }
        }
      },
      locale: "fr"
    })

    const paymentElement = this.elements.create("payment", {
      fields: {
        billingDetails: { address: "if_required" }
      },
      wallets: {
        link: "never"
      }
    })
    paymentElement.mount(this.paymentElementTarget)
  }

  async submit(event) {
    event.preventDefault()
    this.errorMessageTarget.textContent = ""
    this.submitButtonTarget.disabled = true

    const { error: submitError } = await this.elements.submit()
    if (submitError) {
      this.showError(submitError.message)
      return
    }

    const { error } = await this.stripe.confirmSetup({
      elements: this.elements,
      confirmParams: {
        return_url: this.returnUrlValue
      }
    })

    if (error) {
      this.showError(error.message)
    }
  }

  showError(message) {
    this.errorMessageTarget.textContent = message
    this.submitButtonTarget.disabled = false
  }
}
